var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-grid"},[_c('v-container',{attrs:{"fluid":""}},[_c('category-title',{attrs:{"category":_vm.category}})],1),_c('page-grid-internal',{attrs:{"category":_vm.category}}),_c('ebsn-meta',{staticClass:"category-block-footer",attrs:{"target":_vm.category,"path":"category_info.FOOTER_TEXT","tag":"div"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }